<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`"
        :newLayout="true"
        :hideFooter="false"
    >
        <template slot="card-header">
            <h1 v-translate>Sign up to SmartCharts</h1>
            <EnrolmentProgress :currentStage="'Payment'" />
        </template>
        <template slot="card-body">
            <h3
                class="text-center mb-4"
                v-translate
                >
                Enter your payment details
            </h3>
            <form>
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        class="col-md-3"
                        v-translate
                    >Name</label>

                    <div
                        class="col-md-8 col-lg-7 "
                    >
                        <div class="row">
                        <div
                            class="col-md-6"
                        >
                            <input v-model="user.billing_first_name" class="form-control pristine touched" type="text" placeholder="First Name (optional)" >
                        <!-- <i class="cb-token-bar"></i>                   -->
                        </div>
                        <div
                            class="col-md-6 padding-left-0px"

                        >
                            <input v-model="user.billing_last_name" class="form-control pristine touched" type="text" placeholder="Last Name (optional)" >
                        <!-- <i class="cb-token-bar"></i>                   -->
                        </div>
                        </div>
                    </div>
                </div>
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        class="col-md-3"
                        v-translate
                    >Card Number</label>

                    <div
                        class="col-md-8 col-lg-7 "
                    >
                        <input type="text" v-model="payment.card.number" :data-error="(payment.cardErrors.cardNumber)?true:false"  class="form-control pristine touched" v-cardformat:formatCardNumber placeholder="Card Number">
                        <span v-if="payment.cardErrors.cardNumber" class="error-inline ">{{payment.cardErrors.cardNumber}}</span>
                    </div>
                </div>
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        class="col-md-3"
                        v-translate
                    >EXPIRY / CVV</label>

                    <div
                        class="col-md-8 col-lg-7 "
                    >
                        <div class="row">
                        <div
                            class="col-md-6"
                        >
                            <input type="text" v-model="payment.card.expiry" :data-error="(payment.cardErrors.cardExpiry)?true:false" class="form-control pristine touched" v-cardformat:formatCardExpiry placeholder="MM/YYYY">
                            <span v-if="payment.cardErrors.cardExpiry" class="error-inline ">{{payment.cardErrors.cardExpiry}}</span>
                        </div>
                        <div
                            class="col-md-6 padding-left-0px"

                        >
                            <input type="text" v-model="payment.card.cvv" :data-error="(payment.cardErrors.cardCVV)?true:false" class="form-control pristine touched" v-cardformat:formatCardCVC placeholder="CVV">
                            <span v-if="payment.cardErrors.cardCVV" class="error-inline ">{{payment.cardErrors.cardCVV}}</span>
                        </div>
                        </div>
                    </div>
                </div>
                <!-- <CardComponent ref="card"
                :styles="styles"
                :classes="classes"
                :fonts="fonts"
                :locale="locale"
                @ready="onReady"
                @change="onChange"
                >
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        for="country"
                        class="col-md-3"
                        v-translate
                    >Card Number</label>
                    <div
                        class="col-md-8 col-lg-7"
                    >
                        <div class="cb-token-field">
                            <CardNumber ref="cardNumber" class="form-control pristine touched input-bg" @focus="onFocus"/>
                            <i class="cb-token-bar"></i>
                        </div>
                    </div>
                </div>
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        for="country"
                        class="col-md-3"
                        v-translate
                    >Expiry / CVV</label>
                    <div
                        class="col-md-8 col-lg-7"
                    >
                        <div class="cb-token-fields">
                            <div class="cb-token-field">
                                <CardExpiry class="form-control pristine touched input-bg" @focus="onFocus"/>
                                <i class="cb-token-bar"></i>
                            </div>
                            <div class="cb-token-field">
                                <CardCvv class="form-control pristine touched input-bg" @focus="onFocus"/>
                                <i class="cb-token-bar"></i>
                            </div>
                        </div>
                        <div class="error">{{errorMessage | translate}}</div>
                    </div>
                </div>
                </CardComponent> -->
                <template v-if="!use_home_as_billing">
                    <h3
                        class="text-center mb-4"
                        v-translate
                        >
                        Enter your billing address
                    </h3>
                    <div class="form-group justify-content-center align-items-center row">
                        <label
                            for="country"
                            class="col-md-3"
                            v-translate
                        >Country</label>

                        <div
                            class="col-md-8 col-lg-7"
                            v-if="countries.length"
                        >
                            <CountrySelect
                                :required="true"
                                :options="countries"
                                :hasValue="
                                    billing_country ? billing_country : false
                                "
                                :setCountry="setBillingCountry"
                                :getIsoCodeFromName="getIsoCodeFromName"
                                :label="'billing_country'"
                                :handler="countryHandler"
                            >
                                <template slot-scope="{ slotKey }">
                                    <span
                                        :data-key="slotKey"
                                        :class="`iti-flag ${slotKey.toLowerCase()}`"
                                    ></span>&nbsp;
                                </template>
                            </CountrySelect>
                            <InlineError
                                :errors="errors"
                                type="billing_country"
                            />
                        </div>
                        <div
                            class="col-md-8 col-lg-7 loader loader--inline"
                            v-else
                        >
                            <loader />
                        </div>
                    </div>
                    <div class="form-group justify-content-center align-items-start row">
                        <label
                            for="billing_house_number"
                            class="col-md-3"
                            v-translate
                        >House Number</label>

                        <div class="col-md-8 col-lg-7">
                            <Input
                                id="billing_house_number"
                                name="billing_house_number"
                                :rule="{
                                    rules: {
                                        required: user.billing_house_name
                                            ? false
                                            : true
                                    }
                                }"
                                model="user.billing_house_number"
                                module="Enrolment"
                                :maxlength="100"
                            />
                        </div>
                    </div>
                    <div class="form-group justify-content-center align-items-center row">
                        <label
                            for="street_address"
                            class="col-md-3"
                            v-translate
                        >Street Address</label>

                        <div class="col-md-8 col-lg-7">
                            <AutoCompleteInput
                                id="street_address"
                                name="billing_street"
                                model="user.billing_street"
                                module="Enrolment"
                                :autocompleteOptions="predictions"
                                :emulatePlaceChange="emulatePlaceChange"
                                :changeHandler="callAutoComplete"
                            />
                        </div>
                    </div>
                    <div
                    class="form-group justify-content-center align-items-center row"
                    v-show="showState"
                    >
                        <label
                            for="state"
                            class="col-md-3"
                            v-show="!showCounty"
                            v-translate
                        >State</label>
                        <label
                            for="state"
                            class="col-md-3"
                            v-show="showCounty"
                            v-translate
                        >County</label>

                        <div class="col-md-8 col-lg-7">
                            <Input
                                :rule="showState ? 'required' : ''"
                                validateAs="state"
                                id="state"
                                name="billing_state"
                                errorType="billing_state"
                                model="user.billing_state"
                                module="Enrolment"
                                :required="showState"
                                :lazy="false"
                                :maxlength="80"
                            />
                        </div>
                    </div>
                    <div class="form-group justify-content-center align-items-center row">
                        <label
                            for="city"
                            class="col-md-3"
                            v-translate
                        >City</label>

                        <div class="col-md-8 col-lg-7">
                            <Input
                                :rule="'required'"
                                validateAs="city"
                                id="city"
                                name="billing_city"
                                errorType="billing_city"
                                model="user.billing_city"
                                module="Enrolment"
                                :required="true"
                                :lazy="false"
                                :maxlength="40"
                            />
                        </div>
                    </div>
                    <div class="form-group justify-content-center align-items-center row">
                        <label
                            for="postcode"
                            class="col-md-3"
                            v-show="showPostcode"
                            v-translate
                        >Postcode</label>
                        <label
                            for="postcode"
                            class="col-md-3"
                            v-show="!showPostcode"
                            v-translate
                        >Zipcode</label>

                        <div class="col-md-8 col-lg-7">
                            <Input
                                :rule="'required'"
                                validateAs="postcode"
                                id="postcode"
                                name="billing_postcode"
                                errorType="billing_postcode"
                                model="user.billing_postcode"
                                module="Enrolment"
                                :required="true"
                                :lazy="false"
                                :maxlength="20"
                            />
                        </div>
                    </div>
                </template>
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        class="col-md-3"
                        v-translate
                    ></label>
                    <div
                        class="col-md-8 col-lg-7"
                    >
                        <Checkbox
                            module="Enrolment"
                            :disabledCheck="false"
                            modelName="use_home_as_billing"
                            validationRules="required"
                        >
                            <span v-html="useHomeText"></span>
                        </Checkbox>
                    </div>
                </div>
            </form>
            <form
                ref="form"
                method="POST"
                :action="$laraRoute('enrol')"
                @submit.prevent="processStage"
                id="enrol-form"
                novalidate
            >
            </form>
        </template>
        <template slot='card-footer'>
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
            </div>
            <EnrolmentFooter
                :submitHandler="submitForm"
                :processStage="processStage"
                :nextBtn="'Payment Details' | translate"
            />
        </template>
    </Card>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { mapFields } from "vuex-map-fields";
import Card from '@C/Card.vue';
import EnrolmentFooter from './Footer';
import EnrolmentProgress from '@C/EnrolmentProgress';
import EnrolmentMixin from '@M/enrolment';
import errorsMixin from '@M/errors';
import validator from '@M/validationWrapper';
import {CardComponent, CardNumber, CardExpiry, CardCvv} from '@chargebee/chargebee-js-vue-wrapper';
import Checkbox from '@C/Checkbox';
import Input from "@C/Forms/Input";
import InlineError from "@C/Forms/InlineError";
import CountrySelect from "@C/CountrySelect";
import AutoCompleteInput from "@C/AutoCompleteInput";
import autocomplete from "@M/autocomplete";

export default {
    name: 'Payment',
    components: {
        Card,
        EnrolmentProgress,
        CardComponent,
        CardNumber,
        CardExpiry,
        CardCvv,
        EnrolmentFooter,
        Checkbox,
        Input,
        InlineError,
        AutoCompleteInput,
        CountrySelect,
    },
    mixins: [EnrolmentMixin, errorsMixin, validator, autocomplete("Enrolment")],
    created() {
        this.setBillingName();
        this.getOrganisedCountries();
    },
    data() {
        return {
            useHomeText: 'Use home as billing address',
            cardType: '',
            styles: {
                base: {
                    color: '#fff',
                    '::placeholder': {
                        color: '#A0A5BD',
                        fontSize: '0.75rem'
                    },

                    ':focus::placeholder': {
                        color: '#A0A5BD',
                        fontSize: '0.75rem'
                    }
                },
                invalid: {
                    color: '#fff',
                    ':focus': {
                        color: '#FA755A'
                    },
                    '::placeholder': {
                        color: '#FFCCA5'
                    }
                }
            },
            locale: 'en',
            classes: {
                focus: 'focus',
                complete: 'complete',
                invalid: 'invalid',
                empty: 'empty'
            },
            fonts: [
                {
                src: 'https://mysite.com/assets/my-font.woff',
                fontStyle: 'italic',
                fontFamily: 'Myfont',
                fontWeight: '500'
                },
                'https://fonts.googleapis.com/css?family=Lato'
            ],
            cbError: '',
            errorMessage: ''
        }
    },
    methods: {
        ...mapActions('Flash', ['setFlash', 'clearFlash']),
        ...mapActions('Enrolment', ['setBillingFields']),
        ...mapMutations("Enrolment", [
            "setBillingCountry",
        ]),
        ...mapActions(["getOrganisedCountries"]),
        onChange(status) {
            this.clearFlash();
            let errors = {
                ...this.cbError,
                [status.field]: status.error
            }

            this.cbError = errors
            let {message} = Object.values(errors).filter(message => !!message).pop() || {}
            //this.errorMessage = message
            this.setFlash(
                {
                    message: message,
                    key: 'error'
                }
            )
        },
        onFocus(event) {
            console.log(event.field, 'focused')
        },
        onReady(el) {
            el.focus()
        },
        setBillingName() {
            this.setBillingFields({
                billing_first_name: this.user.first_name,
                billing_last_name: this.user.last_name,
            });
        },
        countryHandler(e, firstRun = false) {
            let val = e.value || e.target.value;
            this.getIsoCodeFromName(val, this.countries);
            this.setBillingCountry(val);

            if (!firstRun) {
                this.resetCheckbox();
                this.resetBillingFields();
                this.$nextTick(() => {
                    this.validate();
                });
            }
        },

    },
    computed: {
        ...mapState('Flash', ['flash']),
        ...mapState('Enrolment', ['user', 'use_home_as_billing', 'payment']),
        ...mapState({
            billing_first_name: state => state.Enrolment.user.billing_first_name,
            billing_last_name: state => state.Enrolment.user.billing_last_name,
            billing_country: state => state.Enrolment.user.billing_country,
        }),
        ...mapFields("Enrolment", [
            "user.billing_first_name",
            "user.billing_last_name",
        ]),
        ...mapState(["countries"]),
        showPostcode: function () {
            return (
                this.user.billing_country == 'United Kingdom' ||
                typeof this.user.billing_country == 'undefined'
            );
        },
        showState: function () {
            return (
                this.billing_country == 'United States' ||
                this.billing_country == 'United Kingdom'
            );
        },
        showCounty() {
            return this.billing_country == 'United Kingdom';
        },
    }

}
</script>

<style scoped>
    .cb-token.container {
        margin: auto;
        padding: 10px 0;
        color: #252857;
    }
    .cb-token-wrap{
        max-width: 480px;
        margin: auto;
    }
    .cb-token-contain{
        border-radius: 4px;
        background: transparent;
        padding: 24px;
        box-shadow: 0 2px 5px 0 rgba(0,0,0,0.1);
        margin-bottom: 16px;
    }
    .cb-token-fieldset .cb-token-field{
        margin-bottom: 32px;
    }
    .cb-token-field{
        position: relative;
    }
    .cb-token-fields{
        display: flex;
        margin-left: -16px;
    }
    .cb-token-fields .cb-token-field{
        flex: 1;
        margin-left: 16px;
    }
    .cb-token-field::placeholder{
        font-size: 0.9rem !important;
    }
    .cb-token-label{
        font-size: 12px;
        font-weight: 500;
        color: #3A62BA;
        position: absolute;
        left: 0;
        bottom: 0.25rem;
        pointer-events: none;
        padding-left: 0.125rem;
        z-index: 1;
        font-weight: normal;
        -webkit-transition: all 0.28s ease;
        transition: all 0.28s ease;
    }
    .cb-token-input{
        width: 100%;
        display: block;
        background: transparent;
        border-radius: 0;
        border: none;
        padding: 4px 2px;
        border-width: 0;
        border-color: transparent;
        color: #252857;
        font-size: 16px;
        font-family: inherit;
        font-weight: 500;
        transition: .2s;
        cursor: text;
        /* font-weight: inherit; */
        -webkit-transition: all 0.28s ease;
        transition: all 0.28s ease;
        box-shadow: none;
    }
    .cb-token-input::placeholder{
        font-size: 14px;
        color: #9293AB;
    }
    .cb-token-input:focus::placeholder{
        color: #666;
    }
    .cb-token-input:focus ~ .cb-token-label,
    .cb-token-input.focus ~ .cb-token-label,
    .cb-token-input.complete ~ .cb-token-label,
    .cb-token-input.invalid ~ .cb-token-label{
        font-size: 0.8rem;
        color:#3A62BA;
        bottom: -1.2rem;
    }
    .cb-token-bar{
        position: relative;
        border-bottom: 0.0625rem solid #EBEBEB;
        display: block;
    }
    .cb-token-bar::before {
        content: '';
        height: 0.125rem;
        width: 0;
        left: 50%;
        bottom: -0.0625rem;
        position: absolute;
        background: #252857;
        -webkit-transition: left 0.28s ease, width 0.28s ease;
        transition: left 0.28s ease, width 0.28s ease;
        z-index: 2;
    }
    .cb-token-input:focus ~ .cb-token-bar::before,
    .cb-token-input.focus ~ .cb-token-bar::before,
    .cb-token-input.invalid ~ .cb-token-bar::before{
        width: 100%;
        left: 0;
    }
    .cb-token-input.invalid ~ .cb-token-bar::before{
        background: #E94745;
    }
    .cb-token-button{
        background: #252857;
        color: #fff;
        font-size: 16px;
        font-family: inherit;
        border: none;
        border-radius: 4px;
        padding: 12px 20px;
        display: block;
        width: 100%;
        letter-spacing: .5px;
        transition: .2s;
        cursor: pointer;
    }
    .cb-token-button:hover,
    .cb-token-button:focus{
        background: #191c4a;
    }
    .cb-token-button.submit {
        background-image: url(data:image/svg+xml;base64,PHN2ZyBjbGFzcz0ic3ZnLWxvYWRlciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNTUiIGhlaWdodD0iNTUiIHZpZXdCb3g9IjAgMCA4MCA4MCI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTQwIDcyQzIyLjQgNzIgOCA1Ny42IDggNDBTMjIuNCA4IDQwIDhzMzIgMTQuNCAzMiAzMmMwIDEuMS0uOSAyLTIgMnMtMi0uOS0yLTJjMC0xNS40LTEyLjYtMjgtMjgtMjhTMTIgMjQuNiAxMiA0MHMxMi42IDI4IDI4IDI4YzEuMSAwIDIgLjkgMiAycy0uOSAyLTIgMnoiPjxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZVR5cGU9InhtbCIgYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgNDAgNDAiIHRvPSIzNjAgNDAgNDAiIGR1cj0iMC42cyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiLz48L3BhdGg+PC9zdmc+);
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: 20px;
        color: transparent!important;
        transition-duration: 0s;
    }
    .token {
        color: #555;
        padding: 10px;
        text-align: center;
        font-weight: 500;
    }
    .error {
        color: #ff6c6c;
        padding: 10px;
        text-align: center;
        font-weight: 500;
    }
    .language-palette {
        display: flex;
    }
    .language-palette > .cb-token-button {
        margin: 0 10px;
        padding: 5px 10px;
        height: 50%;
        font-size: 14px;
    }
    .cb-token-button.small {
        height: 30px;
    }
    .input-bg{
        background: rgba(255, 255, 255, 0.03);
        border: 1px solid rgba(226, 246, 255, 0.3);
        border-radius: 4px;
        -webkit-box-shadow: none;
        box-shadow: none;
        padding: 0.75rem 0.75rem !important;
    }
    .padding-left-0px{
        padding-left: 0px;
    }
    @media screen and (max-width: 767px){
        .padding-left-0px{
            padding-left: 15px;
            margin-top: 15px;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/stages/Enrolment/CardPayment.vue